export default {
  title: "Gestion de Contenedores",
  subtitle: "Vista general cross-company de todos los contenedores con datos VIP",
  filters: {
    search: "Buscar contenedor, booking, BL...",
    company: "Todas las empresas",
    status: "Todos los estados",
  },
  table: {
    title: "Contenedores",
    description: "Todos los contenedores de la plataforma",
    headers: {
      container: "Contenedor",
      booking: "Booking",
      company: "Empresa",
      consignee: "Consignee",
      route: "Ruta",
      carrier: "Carrier / Nave",
      dates: "ETD / ETA",
      vip: "VIP %",
      risk: "Riesgo",
      status: "Estado",
      docs: "Docs",
    },
    empty: {
      title: "No se encontraron contenedores",
      message: "Intenta ajustar los filtros de busqueda",
    },
  },
  detail: {
    title: "Detalle del Contenedor",
    vipFields: "Campos VIP",
    editFields: "Editar campos",
    analyze: "Analizar con Agente",
    analyzing: "Analizando...",
    save: "Guardar cambios",
    saving: "Guardando...",
    saved: "Cambios guardados exitosamente",
    saveError: "Error al guardar",
    sources: "Fuentes",
    confidence: "Confianza",
    noSources: "Sin fuentes",
    fieldLabels: {
      container_number: "Numero de Contenedor",
      carrier: "Transportista",
      origin_port: "Puerto Origen",
      destination_port: "Puerto Destino",
      consignee_name: "Consignee",
      etd: "ETD",
      eta: "ETA",
      cargo_value: "Valor de Carga",
      cargo_description: "Descripcion de Carga",
      cargo_details: "Detalles de Carga",
      hs_code: "Codigo HS",
    },
    status: {
      missing: "Faltante",
      uncertain: "Incierto",
      confirmed: "Confirmado",
    },
    agentResult: "Resultado del Agente",
    analyzeError: "Error en el analisis",
    decision: {
      CREATE: "Crear nuevo",
      LINK: "Vincular existente",
      REVIEW: "Necesita revision",
      SKIP: "Omitir",
    },
  },
  loading: "Cargando...",
};
